import React from 'react';

export const Delete = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.1667 24.3333H11.8333C10.9129 24.3333 10.1667 23.5871 10.1667 22.6667V11.8333H8.5V10.1667H11.8333V9.33334C11.8333 8.41286 12.5795 7.66667 13.5 7.66667H18.5C19.4205 7.66667 20.1667 8.41286 20.1667 9.33334V10.1667H23.5V11.8333H21.8333V22.6667C21.8333 23.5871 21.0871 24.3333 20.1667 24.3333ZM11.8333 11.8333V22.6667H20.1667V11.8333H11.8333ZM13.5 9.33334V10.1667H18.5V9.33334H13.5ZM18.5 21H16.8333V13.5H18.5V21ZM15.1667 21H13.5V13.5H15.1667V21Z"
                fill="#E04E2A"
            />
        </svg>
    );
};
